import { CssBaseline, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { RouterProvider } from "react-router/dom";

import { appRouter } from "@mr-portfolio-infrastructure/routes/app-router";
import { defaultLocale, TranslationsProvider } from "@mr-portfolio-infrastructure/translations/translations-provider";
import { StoreProvider } from "@mr-portfolio-store/store-provider";

import { applicationTheme } from "./styles/theme/application-theme";

export function App(): React.JSX.Element {
  return (
    <StoreProvider>
      <TranslationsProvider>
        <ThemeProvider theme={applicationTheme} defaultMode="light">
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={defaultLocale}>
            <CssBaseline />
            <RouterProvider router={appRouter} />
          </LocalizationProvider>
        </ThemeProvider>
      </TranslationsProvider>
    </StoreProvider>
  );
}
